import { render, staticRenderFns } from "./variant.vue?vue&type=template&id=444cd673&scoped=true&"
import script from "./variant.vue?vue&type=script&lang=js&"
export * from "./variant.vue?vue&type=script&lang=js&"
import style0 from "./variant.vue?vue&type=style&index=0&id=444cd673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444cd673",
  null
  
)

export default component.exports